const materials = [
  { id: "heavy-duty-pvc", name: "Heavy-Duty PVC", desc: "Maximum durability for demanding environments. UV-stabilized, fire-retardant." },
  { id: "clear-pvc", name: "Clear PVC", desc: "Transparent panels for visibility while maintaining separation and protection." },
  { id: "mesh", name: "Mesh", desc: "Ventilated fabric for airflow. Ideal for dust containment while allowing air circulation." },
];

const colors = [
  { id: "clear", name: "Clear", hex: "transparent", border: true },
  { id: "white", name: "White", hex: "#FFFFFF" },
  { id: "orange", name: "Orange (Safety)", hex: "#FF5722" },
  { id: "blue", name: "Blue", hex: "#1E88E5" },
  { id: "yellow", name: "Yellow", hex: "#FDD835" },
  { id: "black", name: "Black", hex: "#212121" },
  { id: "grey", name: "Grey", hex: "#757575" },
  { id: "green", name: "Green", hex: "#43A047" },
  { id: "red", name: "Red", hex: "#E53935" },
  { id: "custom", name: "Custom", hex: null },
];

export default function StepMaterial({ form, setForm }) {
  return (
    <div>
      <h2
        className="text-2xl sm:text-3xl font-bold tracking-tight mb-2"
        style={{ fontFamily: "'Clash Display', sans-serif" }}
      >
        Material & Colour
      </h2>
      <p className="text-sm text-[#A3A3A3] mb-8">Choose the material grade and colour for your product.</p>

      {/* Material */}
      <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" style={{ fontFamily: "'Clash Display', sans-serif" }}>
        Material
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
        {materials.map((m) => {
          const selected = form.material === m.id;
          return (
            <button
              key={m.id}
              type="button"
              data-testid={`material-${m.id}`}
              onClick={() => setForm((prev) => ({ ...prev, material: m.id }))}
              className={`text-left p-5 border transition-all duration-200 ${
                selected
                  ? "border-[#FF5722] bg-[#FF5722]/5"
                  : "border-[#2E2E2E] bg-[#141414] hover:border-[#FF5722]/50"
              }`}
            >
              <p className={`font-bold text-sm mb-1 ${selected ? "text-[#FF5722]" : "text-white"}`} style={{ fontFamily: "'Clash Display', sans-serif" }}>
                {m.name}
              </p>
              <p className="text-xs text-[#A3A3A3] leading-relaxed">{m.desc}</p>
            </button>
          );
        })}
      </div>

      {/* Colour */}
      <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" style={{ fontFamily: "'Clash Display', sans-serif" }}>
        Colour
      </h3>
      <div className="flex flex-wrap gap-3">
        {colors.map((c) => {
          const selected = form.color === c.id;
          return (
            <button
              key={c.id}
              type="button"
              data-testid={`color-${c.id}`}
              onClick={() => setForm((prev) => ({ ...prev, color: c.id }))}
              className={`flex flex-col items-center gap-2 p-3 border transition-all duration-200 min-w-[70px] ${
                selected
                  ? "border-[#FF5722] bg-[#FF5722]/5"
                  : "border-[#2E2E2E] bg-[#141414] hover:border-[#FF5722]/50"
              }`}
            >
              {c.hex !== null ? (
                <div
                  className={`w-8 h-8 ${c.border ? "border border-[#A3A3A3]" : ""}`}
                  style={{ backgroundColor: c.hex === "transparent" ? "transparent" : c.hex,
                    backgroundImage: c.hex === "transparent" ? "linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%)" : "none",
                    backgroundSize: "8px 8px",
                    backgroundPosition: "0 0, 4px 4px"
                  }}
                />
              ) : (
                <div className="w-8 h-8 border border-dashed border-[#A3A3A3] flex items-center justify-center text-[#A3A3A3] text-[10px]">?</div>
              )}
              <span className={`text-[10px] font-medium ${selected ? "text-[#FF5722]" : "text-[#A3A3A3]"}`}>{c.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
